import { Suspense, lazy, useState } from 'react';
import { SalesDemoUser } from '@wetags/sales-demo';
import { useHotkeys } from 'react-hotkeys-hook';
import { getUser } from '@frontend/auth-helpers';

export const ENTRY_LANDING_PAGE_WETAG = 'creation-flow' as const;

const sideLauncherAccessCache = new Map<string, Promise<boolean>>();

const getCachedSideLauncherAccess = (userId: string) => {
  const cachedAccess = sideLauncherAccessCache.get(userId);
  if (cachedAccess) {
    return cachedAccess;
  }

  const accessPromise = SalesDemoUser.fetchValue(ENTRY_LANDING_PAGE_WETAG).then((hasAccess) => Boolean(hasAccess));
  sideLauncherAccessCache.set(userId, accessPromise);

  return accessPromise;
};

const LazySideLauncher = lazy(() => import('./side-launcher-content'));

export const SideLauncherHotkeyController = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleHotkeyPress = async () => {
    if (isVisible) {
      setIsVisible(false);
      return;
    }

    const currentUser = getUser();
    if (!currentUser) {
      return;
    }

    /**
     * If the user is a weave-users.com user, we want to show the side launcher regardless of wetag access.
     * Failing that, we also want to check if the user has access to the side launcher wetag, and show it if they do.
     * All of this happens only on hotkey press.
     */
    const isEligibleUser = currentUser.username.endsWith('@weave-users.com');

    if (isEligibleUser) {
      console.log('User is eligible for side launcher, showing it');
      setIsVisible(true);
      return;
    }

    const hasLauncherAccess = await getCachedSideLauncherAccess(currentUser.userID);

    if (hasLauncherAccess) {
      setIsVisible(true);
    }
  };

  useHotkeys(
    'cmd+shift+l, ctrl+shift+l',
    () => {
      void handleHotkeyPress();
    },
    [isVisible]
  );

  return isVisible ? (
    <Suspense fallback={null}>
      <LazySideLauncher />
    </Suspense>
  ) : null;
};
